var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    { staticClass: "pa-0 py-2", staticStyle: { height: "52px" } },
    [
      _c(
        "v-list-item",
        { staticClass: "header" },
        [
          _c(
            "v-list-item-avatar",
            { staticClass: "mr-0" },
            [_c(_vm.icon, { tag: "component", staticClass: "logoFormSVG" })],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item-content",
            [
              _c(
                "v-list-item-title",
                {
                  staticClass: "object-title",
                  class: { "mb-1": !_vm.subTitle }
                },
                [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
              ),
              _vm._v(" "),
              _vm.subTitle
                ? _c(
                    "v-list-item-subtitle",
                    { staticClass: "object-subtitle" },
                    [_vm._v("\n        " + _vm._s(_vm.subTitle) + "\n      ")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item-action",
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", "x-small": "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34bc9270", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bc9270","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/Forms/_Molecules/ObjectFormHeader.vue
// module id = null
// module chunks = 